import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Parampara from "@/pages/Parampara";
import SamsthanaIdols from "@/pages/SamsthanaIdols";
import SacredPlaces from "@/pages/SacredPlaces";
import { LanguageProvider } from "@/i18n";
import Events from "@/pages/Events";
import EventDetails from "@/pages/EventDetails";
import Sanchara from "@/pages/Sanchara";
import Gallery from "@/pages/Gallery";
import DailyEvents from "@/pages/DailyEvents";
import Sevas from "@/pages/Sevas";
import SevaBooking from "@/pages/SevaBooking";
import Contact from "@/pages/Contact";
import "@/App.css";

function App() {
  return (
    <LanguageProvider>
    <HashRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/parampara" element={<Parampara />} />
          <Route path="/idols" element={<SamsthanaIdols />} />
          <Route path="/sacred-places" element={<SacredPlaces />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:eventId" element={<EventDetails />} />
          <Route path="/sanchara" element={<Sanchara />} />
          <Route path="/branches" element={<Navigate to="/contact" replace />} />
          <Route path="/gallery" element={<Gallery />} />
          {/* <Route path="/daily-events" element={<DailyEvents />} /> */}
          <Route path="/sevas" element={<Sevas />} />
          <Route path="/sevas/book/:sevaId" element={<SevaBooking />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </Layout>
      <Toaster position="top-center" richColors closeButton />
    </HashRouter>
    </LanguageProvider>
  );
}

export default App;
